import { createMuiTheme } from '@material-ui/core/styles';

import overrides from './overrides';
import palette from './palette';
import props from './props';
import typography from './typography';

export default createMuiTheme({
  overrides,
  palette,
  typography,
  props,
});
